import { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectPrimarySecurity } from '../../selectors/home'
import { updateMarketDepthSecurity } from '../../reducer/common.reducer'

/** Layout/primary → market depth (incl. exchange). Order book does not update layout. */
function MarketDepthSync() {
    const dispatch = useDispatch()
    const { primary: primarySecurity } = useSelector(selectPrimarySecurity)

    useEffect(() => {
        if (!primarySecurity) return
        dispatch(updateMarketDepthSecurity(primarySecurity))
    }, [primarySecurity?.exchange, primarySecurity?.code, dispatch])

    return null
}

export default memo(MarketDepthSync)
